import { jsx as t } from "react/jsx-runtime";
import f from "react";
import { Title as l } from "../Title/Title.js";
import { clsx as i } from "../../utils/clsx.js";
import '../../assets/CountryFlag.css';const m = "_root_n4jzf_1", u = {
  root: m
}, x = f.forwardRef(function(r, e) {
  const {
    country: o,
    className: s,
    title: n,
    forceShow: a = !1
  } = r;
  if (!a && (o === "001" || o === "AQ" || o === "aq"))
    return null;
  const c = i(u.root, s, `fi-${o.toLowerCase()}`);
  return /* @__PURE__ */ t(l, { title: n, children: /* @__PURE__ */ t("div", { ref: e, className: c }) });
});
export {
  x as CountryFlag
};
